import type { EventLogItem } from "@/components/layout-2/event-log";
import type { EventLogEntryPayload } from "@/types/dynamic-detail";

/** The entries of an "event-log" tab (server `EventLogTab`) as `EventLog` items. */
export function eventLogItemsFromPayload(events: EventLogEntryPayload[] | null | undefined): EventLogItem[] {
    return (events ?? []).map(({ group_key, ...event }) => ({ ...event, groupKey: group_key }));
}
